import { styled } from '@mui/material/styles';
import MuiAppBar from '@mui/material/AppBar';
import { useSelector } from 'react-redux';
import { ToolbarAppbar } from './components/ToolbarAppbar';

const drawerWidth = 240;
const minDrawerWidth = 60;

export const NavbarLayout = () => {

    const { drawerIsOpen } = useSelector(state => state.layout);

    return (
        <AppBar sx={{ zIndex: 9995 }} position="sticky" color='info' open={drawerIsOpen} elevation={0}  >
            <ToolbarAppbar color='primary'/>
        </AppBar>
    )
}


const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: `calc(100% - ${minDrawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: minDrawerWidth,
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: drawerWidth,
    }),
}));

